/** The wordmark tile used in the gate and rail. */
export function Logo() {
  return (
    <div
      className="flex h-[34px] w-[34px] items-center justify-center rounded-lg bg-accent font-mono text-[13px] font-bold text-accentInk"
      aria-hidden
    >
      C·db
    </div>
  );
}
